import React, { useState } from 'react';

const SECTIONS = [
  {
    title: '1. 収集する情報',
    body: `当社は、本サービスの提供にあたり、以下の情報を収集します。\n\n【アカウント情報】\n・メールアドレス\n・パスワード（ハッシュ化して保存）\n・2段階認証設定情報\n\n【顔認識データ】\n・お子様の顔写真（顔の特徴ベクトルへの変換にのみ使用）\n・顔の特徴ベクトルデータ（AWS Rekognitionが生成する数値データ）\n※写真ファイル自体はお客様のデバイスまたはGoogle Driveに保存され、当社サーバーには保存されません。\n\n【利用情報】\n・振り分け処理の実行履歴（日時・処理枚数）\n・サービスのご利用状況（プラン・累計処理枚数）\n\n【技術情報】\n・ログデータ（IPアドレス、アクセス日時）`,
  },
  {
    title: '2. 情報の利用目的',
    body: `収集した情報は、以下の目的で利用します。\n\n1. 本サービスの提供・運営・改善\n2. ユーザーの本人確認・認証\n3. 写真の顔認識・自動振り分け処理\n4. 利用状況の集計・分析（個人を特定しない形式）\n5. サービスに関する重要なお知らせの送付\n6. 利用規約違反への対応\n7. 料金の請求・管理`,
  },
  {
    title: '3. 委託先・サービスプロバイダー',
    body: `当社は、以下のサービスプロバイダーに個人情報の取扱いを委託してサービスを提供しています。\n\n【AWS（Amazon Web Services Japan G.K.）】\n・顔認識処理：AWS Rekognition\n・データ保管：AWS RDS（東京リージョン）\n・メール送信：AWS SES（東京リージョン）\n・顔の特徴データ・アカウント情報はAWSサーバー（日本国内）に保存されます\n・AWS プライバシーポリシー: https://aws.amazon.com/jp/privacy/\n\n【Stripe（Stripe Payments Japan株式会社 / Stripe, Inc.（米国））】\n・有料プランの決済処理・カスタマーポータル\n・支払い情報（クレジットカード番号等）は当社サーバーには保存されず、Stripe が直接処理します\n・当社は Stripe から決済成否・サブスクリプション状態のみを受領します\n・契約者の氏名・メールアドレス等は、決済処理の目的で Stripe へ提供されます\n・Stripe は米国にサーバーを持ち、データの一部が米国へ移転される場合があります（詳細は「4-2. 外国への個人データの移転」を参照）\n・Stripe プライバシーポリシー: https://stripe.com/jp/privacy\n\n【Google（Google LLC）】\n・Google Drive API 経由でのファイルアクセス（ユーザーが許可した場合のみ）\n・当社は Google Drive 内の写真を読み取り専用でアクセスします\n・Google プライバシーポリシー: https://policies.google.com/privacy\n\n上記以外の第三者に個人情報を提供することはありません。ただし、法令に基づく開示要請があった場合はこの限りではありません。`,
  },
  {
    title: '4-2. 外国への個人データの移転',
    body: `個人情報保護法第28条に基づき、外国にある第三者への個人データの提供について以下の通り情報提供いたします。\n\n【Stripe, Inc.（米国）】\n・移転される情報：契約者氏名・メールアドレス・決済関連情報（カード番号は当社を経由せず Stripe が直接受領）\n・移転先国：アメリカ合衆国\n・米国の個人情報保護制度：米国には EU 一般データ保護規則（GDPR）に相当する包括的な個人情報保護法は存在しませんが、Stripe は SOC 1 / SOC 2 Type II、PCI DSS Level 1 等の国際的なセキュリティ認証を取得しており、業界標準的な保護措置を講じています。\n・Stripe が講じる保護措置：標準契約条項（SCC）の活用、暗号化、アクセス制御、監査ログ等\n・参考：https://stripe.com/jp/legal/privacy-center\n\n【Google LLC（米国）— ユーザーが Google Drive 連携を許可した場合のみ】\n・移転される情報：ユーザーの Google アカウントに紐付く Drive 上のファイルへのアクセストークン\n・移転先国：アメリカ合衆国\n・Google が講じる保護措置：標準契約条項（SCC）の活用、暗号化、Google Cloud のセキュリティ基準\n\n【AWS — 東京リージョン利用のため通常は国内に留まる】\n・通常、AWS Rekognition / RDS / SES は東京リージョン（日本国内）でのみデータを処理します。\n・障害復旧等の例外的な場面で他リージョンが使われる可能性は否定できません（AWS データ処理契約に基づく保護措置あり）。`,
  },
  {
    title: '4. データの保存・セキュリティ',
    body: `【保存場所】\n・アカウント情報・利用履歴：AWS RDS（東京リージョン）\n・顔の特徴データ：AWS Rekognition（東京リージョン）\n・写真ファイル：お客様のデバイスまたはGoogle Drive（当社は保存しません）\n\n【セキュリティ対策】\n・通信はすべてHTTPS（TLS 1.2以上）で暗号化\n・パスワードはbcryptでハッシュ化\n・JWT（JSON Web Token）によるセッション管理\n・2段階認証（TOTP）のサポート\n\n【データ保持期間】\n・アカウント情報：退会まで\n・顔の特徴データ：登録削除時に即時削除\n・利用ログ：1年間保持後に削除`,
  },
  {
    title: '5. お子様のデータについて（事業者ユーザー向け）',
    body: `本サービスは、保育園・幼稚園・スポーツクラブ・写真館等の事業者ユーザーが、業務上預かっている子供の顔情報を扱うことを想定しています。\n\n【保護者同意の取得は事業者ユーザーの責任】\n13歳未満の子供の個人情報を取り扱うにあたり、保護者（親権者）からの事前同意は事業者ユーザー側で取得していただく必要があります。当社は、事業者ユーザーが保護者から適切に同意を得ていることを前提に本サービスを提供します（利用規約第4条参照）。\n\n【データの取り扱い】\n1. 登録された子供の顔データは、事業者ユーザーの管理下に置かれます。\n2. 当社は事業者ユーザーの個別の指示に従って顔データを処理します（個人情報の取扱いの委託）。\n3. 登録した顔データは、事業者ユーザーがいつでも削除できます。\n4. 退会時はすべての顔データを 30 日以内に完全削除します（即時完全削除のオプションもあります）。\n5. 当社は子供の顔データを本サービス提供以外の目的（マーケティング・AI学習等）で一切利用しません。\n6. 当社は子供の顔データを第三者へ提供しません（AWS Rekognition による処理は委託先での処理であり、第三者提供にはあたりません）。\n\n【保護者からの問い合わせ】\nお子様の保護者の方から開示・訂正・削除等のご要望があった場合、第一次的には登録した事業者ユーザー（園・施設等）にお問い合わせいただくこととなります。事業者ユーザーは、保護者からの請求があった場合、本サービスの機能を通じて、または当社サポートへの連絡により、必要な対応を行うものとします。`,
  },
  {
    title: '6. ユーザーの権利',
    body: `ユーザーは、自身の個人情報について以下の権利を有します。\n\n1. 【開示】登録情報の確認・開示を請求できます\n2. 【訂正】不正確な情報の訂正を請求できます\n3. 【削除】顔データやアカウント情報の削除を請求できます\n4. 【利用停止】個人情報の利用停止を請求できます\n5. 【Google Drive連携解除】いつでもGoogle Driveとの連携を解除できます\n\nこれらの請求はサービス内の設定画面、またはサポートメール（info@036base.com）からお申し込みください。合理的な期間内に対応いたします。`,
  },
  {
    title: '7. Cookieの使用',
    body: `本サービスは、ユーザー体験の向上のためにCookieおよびローカルストレージを使用しています。\n\n・認証トークン（ログイン状態の維持）\n・UI設定（テーマ等）\n\n第三者の広告目的でのCookieは使用していません。ブラウザの設定でCookieを無効にすることができますが、一部機能が利用できなくなる場合があります。`,
  },
  {
    title: '8. プライバシーポリシーの変更',
    body: `当社は、法令の変更またはサービスの変更に伴い、本ポリシーを変更することがあります。重要な変更がある場合は、サービス上またはメールでお知らせします。変更後も本サービスを継続してご利用された場合、変更後のポリシーに同意したものとみなします。`,
  },
  {
    title: '9. お問い合わせ',
    body: `個人情報の取り扱いに関するお問い合わせは、以下の窓口までご連絡ください。\n\n【個人情報保護管理者】\n株式会社オーサム・ベース\nメール：info@036base.com\n\nご連絡をいただいた場合、合理的な期間内に回答いたします。`,
  },
];

export default function PrivacyPage({ standalone = false }) {
  const [open, setOpen] = useState(null);

  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <div className={standalone ? '' : 'page'} style={standalone ? { padding: '40px 24px', maxWidth: 760, margin: '0 auto' } : {}}>
      {!standalone && (
        <div className="page-header animate-in">
          <h1 className="page-title">プライバシーポリシー</h1>
          <p className="page-subtitle">個人情報の取り扱いについて</p>
        </div>
      )}

      <div className={standalone ? '' : 'page-body animate-in-delay-1'} style={{ maxWidth: 720 }}>

        {standalone && (
          <div style={{ marginBottom: 32, textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🔒</div>
            <h1 style={{ fontSize: 24, fontWeight: 800, margin: '0 0 4px' }}>プライバシーポリシー</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>個人情報の取り扱いについて</p>
          </div>
        )}

        {/* 基本方針 */}
        <div style={{
          background: 'linear-gradient(135deg, #FF6B9D22 0%, #9B5FE322 100%)',
          border: '1px solid var(--primary)',
          borderRadius: 14,
          padding: '18px 20px',
          marginBottom: 24,
          fontSize: 13,
          lineHeight: 1.8,
        }}>
          <strong>🔐 基本方針</strong><br />
          株式会社オーサム・ベースは、お客様の個人情報およびお子様の顔データを適切に保護することを最重要事項として、本プライバシーポリシーを定めます。収集した情報は、サービス提供に必要な範囲でのみ利用し、第三者への不当な提供は行いません。
        </div>

        {/* ハイライト */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: 12,
          marginBottom: 24,
        }}>
          {[
            { icon: '📸', label: '写真は\n保存しない', desc: '顔の特徴データのみ' },
            { icon: '🔒', label: 'HTTPS通信\n暗号化', desc: 'すべての通信を保護' },
            { icon: '🗑️', label: 'いつでも\n削除可能', desc: '退会時に完全削除' },
          ].map((item, i) => (
            <div key={i} style={{
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 12,
              padding: '14px 12px',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: 24, marginBottom: 6 }}>{item.icon}</div>
              <div style={{ fontSize: 12, fontWeight: 700, lineHeight: 1.4, whiteSpace: 'pre-line' }}>{item.label}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>{item.desc}</div>
            </div>
          ))}
        </div>

        {/* 条文アコーディオン */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 32 }}>
          {SECTIONS.map((sec, i) => (
            <div key={i} style={{
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 10,
              overflow: 'hidden',
            }}>
              <button
                onClick={() => toggle(i)}
                style={{
                  width: '100%', textAlign: 'left', padding: '14px 16px',
                  background: 'none', border: 'none', cursor: 'pointer',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  fontSize: 13, fontWeight: 700, color: 'var(--text-primary)',
                }}
              >
                <span>{sec.title}</span>
                <span style={{ fontSize: 14, color: 'var(--text-muted)', flexShrink: 0, marginLeft: 8 }}>
                  {open === i ? '▲' : '▼'}
                </span>
              </button>
              {open === i && (
                <div style={{
                  padding: '0 16px 16px',
                  borderTop: '1px solid var(--border)',
                  paddingTop: 12,
                  fontSize: 13,
                  lineHeight: 2,
                  color: 'var(--text-muted)',
                  whiteSpace: 'pre-wrap',
                }}>
                  {sec.body}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* 施行日 */}
        <div style={{
          textAlign: 'right',
          fontSize: 12,
          color: 'var(--text-muted)',
          marginBottom: 24,
        }}>
          制定日：2025年1月1日<br />
          最終改定：2026年5月1日
        </div>

        {/* お問い合わせ */}
        <div style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 14,
          padding: '16px 20px',
          textAlign: 'center',
          fontSize: 13,
        }}>
          <p style={{ margin: '0 0 4px', fontWeight: 600 }}>プライバシーに関するお問い合わせ</p>
          <p style={{ margin: 0, color: 'var(--text-muted)' }}>
            <a href="mailto:info@036base.com" style={{ color: 'var(--primary)' }}>info@036base.com</a>
          </p>
        </div>

      </div>
    </div>
  );
}
